export enum CompanyTypeEnum {
  IMPORTER = 'IMPORTER',
  BUYER = 'BUYER',
  CONSIGNEE = 'CONSIGNEE'
}
